// OmniClinicalBridge V2.0 - Features Testing Button
import { Link } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';

export function FeaturesTestingButton() {
  // Hide in production unless explicitly enabled
  const showButton = import.meta.env.DEV || import.meta.env.VITE_SHOW_TEST_FEATURES === 'true';
  
  if (!showButton) return null;
  
  return (
    <Link
      to="/features-demo"
      className="fixed bottom-6 right-6 z-[99999] flex items-center gap-2 px-5 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-full shadow-2xl hover:shadow-purple-500/50 hover:scale-110 transition-all duration-300 border-2 border-white/20"
      style={{ 
        position: 'fixed', 
        bottom: '24px', 
        right: '24px', 
        zIndex: 99999,
        boxShadow: '0 10px 40px rgba(147, 51, 234, 0.5)'
      }}
    >
      <FlaskConical className="w-6 h-6" />
      <span className="font-bold text-lg">Test Features</span>
      <span className="absolute -top-2 -right-2 w-7 h-7 bg-green-500 rounded-full flex items-center justify-center text-sm font-bold animate-pulse border-2 border-white">7</span>
    </Link>
  );
}
